// B35-2 / B35-3 — the prior year's own data source ("Prior year: Main GL / Trial Balance upload / No data") next to the
// current year's "Source: …" badge, the notice "this TB is stored but not used" (a GL is loaded for that year), the TB year
// picker of the TB page and its PY column. EN + AR, merged into lib/i18n.js translations (big-file rule).
export const I18N_B35 = {
  en: {
    b35: {
      priorLabel: "Prior year",
      priorGl: "Main GL",
      priorTb: "Trial Balance upload",
      priorNone: "No data",
      noticeTitle: "Trial balance stored but not used",
      noticeText: "A GL is loaded for this year, so this TB is stored but not used. Figures come from the GL.",
      noticeCurrent: "Current year",
      noticePrior: "Prior year",
      tbYear: "Trial balance for",
      tbYearCurrent: "Current year",
      tbYearPrior: "Prior year",
      pyNet: "PY net",
    },
  },
  ar: {
    b35: {
      priorLabel: "السنة السابقة",
      priorGl: "الأستاذ العام الرئيسي",
      priorTb: "ميزان المراجعة المرفوع",
      priorNone: "لا توجد بيانات",
      noticeTitle: "ميزان المراجعة محفوظ لكنه غير مستخدم",
      noticeText: "يوجد دفتر أستاذ عام محمّل لهذه السنة، لذلك حُفظ ميزان المراجعة هذا ولكنه غير مستخدم. الأرقام مأخوذة من دفتر الأستاذ العام.",
      noticeCurrent: "السنة الحالية",
      noticePrior: "السنة السابقة",
      tbYear: "ميزان المراجعة عن",
      tbYearCurrent: "السنة الحالية",
      tbYearPrior: "السنة السابقة",
      pyNet: "صافي السنة السابقة",
    },
  },
};

export default I18N_B35;
